// removed by extract-text-webpack-plugin
module.exports = {"card-comparison-container":"CardComparisonContainer__card-comparison-container","cardComparisonContainer":"CardComparisonContainer__card-comparison-container"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/CardComparisonContainer.css
// module id = 1307
// module chunks = 8